import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { index, destroy } from '../../../store/actions/cupons.action'
import { AppBar, Button, CircularProgress, Divider, IconButton, Menu, MenuItem, Slide, Typography, Toolbar } from '@material-ui/core'
import { FaTrash } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { IoTicketSharp } from "react-icons/io5"
import { FcFilingCabinet, FcAcceptDatabase } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../components'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import { SCROLL } from '../../../config/App'


export default function Cupons(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const { promotions, success } = useSelector(state => state.cuponsReducer)

    const [isLoading, setLoading] = React.useState(true)
    const [ isLoadMore, setLoadMore ] = React.useState(false)
    const [query, setQuery] = React.useState({ page: 1 , campaign_id: campaign_id})

    const [state, setState] = React.useState({
        menuEl: null,
        isDeleted: null,
        confirmEl: null
    })

    React.useEffect(() => {
        if(success) {
            setLoading(true)
            dispatch(index({ page: 1 , campaign_id: campaign_id}, isLoadMore)).then(res => {
                setLoading(false)
                setLoadMore(false)
            })
        }
    },[success])

    React.useEffect(() => {
        document.addEventListener('scroll', _handleScroll)
        return () => document.removeEventListener('scroll', _handleScroll)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    })

    React.useEffect(() => {
        _index(isLoadMore)
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [query])

    React.useEffect(() => {
        if(isLoadMore) {
            setQuery({
                ...query,
                page: query.page + 1
            })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoadMore])

    const _handleScroll = (event) => {
        const { scrollTop, scrollHeight, clientHeight } = event.srcElement.documentElement
        let scroll = scrollHeight - (clientHeight + scrollTop)
        if(scroll < SCROLL) {
            if(!isLoadMore && _handleLoadMore());
        }
    }

    const _handleLoadMore = () => {
        if(promotions.current_page < promotions.last_page) { 
            setLoadMore(true)
        }
    }

    const _index = (loadMore) => {
        dispatch(index(query, loadMore)).then(res => {
            setLoading(false)
            setLoadMore(false)
        })
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const handlePage = (page, id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                uid: id,
                campaign_id: campaign_id
            }
        }))
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Cupons</Typography>
                    
                    <Button onClick={() => handlePage('cupons-create')} color="inherit" className="ms-auto">
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                <>
                    {(promotions.data.length < 1) &&
                        <div className="card card-body">
                            <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                <FcFilingCabinet size="70" />
                                <h6 className="mt-4 text-muted">Nenhum registro cadastrado</h6>
                            </div>
                        </div>
                    }

                    {(promotions.data.length > 0) &&
                        <>
                            <div className="card-body">
                                <label className="label-custom">{promotions.total.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                            </div>

                            {promotions.data.map((item, index) => (
                                <div className="card shadow-lg mb-3" key={index}>
                                    <div className="card-body pt-2">
                                        <div className="d-flex justify-content-between align-items-center mb-3">
                                            <h5 className="text-ellipsis pt-3"><IoTicketSharp color="#28a745" size="1.2em" className="me-2" /> {item.title}</h5>

                                            <IconButton id={index} onClick={event => setState({ menuEl: event.currentTarget })}>
                                                <MdMoreHoriz size="1.2em" />
                                            </IconButton>

                                            {(Boolean(state.menuEl)) &&
                                                <Menu
                                                    anchorEl={state.menuEl}
                                                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                    TransitionComponent={Transition}
                                                    open={(index === parseInt(state.menuEl.id))}
                                                    onClose={() => setState({ menuEl: null })}
                                                >

                                                    <MenuItem onClick={() => setState({ confirmElB: item.id })}>
                                                        <FcAcceptDatabase size="1.2em" className="me-4" /> <strong>Tornar Principal</strong>
                                                    </MenuItem>

                                                    <Divider />

                                                    <MenuItem onClick={() => setState({ confirmEl: item.id })}>
                                                        <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Remover</strong>
                                                    </MenuItem>
                                                    
                                                    <div className='mt-3'></div>
                                                </Menu>
                                            }
                                            {(state.confirmEl === item.id) && 
                                                <Confirm
                                                    open={(item.id === state.confirmEl)}
                                                    onConfirm={() => _destroy(item.id)}
                                                    onClose={() => setState({ confirmEl: null })}
                                                />
                                            }
                                        </div>
                                                
                                        <div className="d-flex justify-content-between">
                                            <div>
                                                <small className="text-muted d-block">Inicio</small>
                                                <label className="label-custom">{new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(item.created_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.created_at))}</label>
                                            </div>

                                            <div>
                                                <small className="text-muted d-block">Término</small>
                                                <label className="label-custom">{new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(item.expires_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.expires_at))}</label>
                                            </div>
                                        </div>

                                        <hr className="hr-muted"/>

                                        <div className="d-flex justify-content-between">
                                            <strong>Cupons Gerados</strong>
                                            <h5 onClick={() => console.log()}><span className="badge bg-primary pointer">{item.total_count ? item.total_count : (item.total_count === 0 ? item.total_count : 'ver')}</span></h5>
                                        </div>

                                        <hr className="hr-muted"/>

                                        <div className="d-flex justify-content-between">
                                            <strong>Valor</strong>
                                            <h5 className="fw-bold">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.amount)}</h5>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </>
                    }
                </>
            }
            </div>
        </>
    )
}